// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8982":"9e4d0971009a1c76","91724":"294b2d2d7cf9e7f6","97027":"395541dc5233f0de"}[chunkId] + ".css";
};